<template>
    <div class="back-to-top blue">
        <div class="item to-top-btn show" @click="scrollToTop">返回顶部</div>
        <div
            class="item qrcode"
            :class="{ active: qrActive }"
            @click.stop="toggleQr"
            @touchend.prevent="toggleQr"
        >
            <span>关注我们</span>
            <div class="qr" @click.stop>
                <img :src="qrImg" alt="数位官方公众号" />
                <br />微信扫一扫关注
            </div>
        </div>
        <div class="item sszx" @click="openConsult">在线咨询</div>
    </div>
</template>

<script>
function isMobileDevice() {
    return (
        /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ||
        window.innerWidth <= 768
    );
}

export default {
    name: 'FloatToolbar',
    data() {
        return {
            qrActive: false,
            qrImg: require('@/assets/img/float-toolbar/swgf.png'),
            autoOpenTimer: null,
            readyPollTimer: null
        };
    },
    mounted() {
        document.addEventListener('click', this.handleOutsideClick);
        document.addEventListener('touchend', this.handleOutsideClick);
        this.scheduleAutoOpenConsult();
    },
    beforeDestroy() {
        document.removeEventListener('click', this.handleOutsideClick);
        document.removeEventListener('touchend', this.handleOutsideClick);
        if (this.autoOpenTimer) clearTimeout(this.autoOpenTimer);
        if (this.readyPollTimer) clearInterval(this.readyPollTimer);
    },
    methods: {
        scrollToTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            const app = document.getElementById('app');
            if (app && typeof app.scrollTo === 'function') {
                app.scrollTo({ top: 0, behavior: 'smooth' });
            }
            if (window.$) {
                $('html, body, #app').animate({ scrollTop: 0 }, 300);
            }
        },
        toggleQr() {
            this.qrActive = !this.qrActive;
        },
        handleOutsideClick(e) {
            const root = this.$el;
            if (root && !root.contains(e.target)) {
                this.qrActive = false;
            }
        },
        openConsult() {
            if (typeof window.ysf === 'function') {
                window.ysf('open');
            }
        },
        /** 桌面端进入页面后自动打开客服；关闭后仍只显示本浮层（七鱼默认按钮已 CSS 隐藏） */
        scheduleAutoOpenConsult() {
            if (isMobileDevice()) return;
            this.autoOpenTimer = setTimeout(() => {
                this.openConsultWhenReady();
            }, 1500);
        },
        openConsultWhenReady() {
            if (typeof window.ysf === 'function') {
                window.ysf('open');
                return;
            }
            let tries = 0;
            this.readyPollTimer = setInterval(() => {
                tries += 1;
                if (typeof window.ysf === 'function') {
                    clearInterval(this.readyPollTimer);
                    this.readyPollTimer = null;
                    window.ysf('open');
                } else if (tries >= 20) {
                    clearInterval(this.readyPollTimer);
                    this.readyPollTimer = null;
                }
            }, 300);
        }
    }
};
</script>

<style scoped lang="less">
.back-to-top {
    position: fixed;
    bottom: 100px;
    right: 20px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2), 0 4px 12px rgba(0, 0, 0, 0.15);
    z-index: 100;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    overflow: visible;
}

.back-to-top .item {
    user-select: none;
    width: 68px;
    height: 80px;
    background-color: #fff;
    font-size: 12px;
    text-align: center;
    color: #8893a7;
    cursor: pointer;
    padding-top: 50px;
    padding-bottom: 10px;
    background-position: center 10px;
    background-size: 40px 40px;
    background-repeat: no-repeat;
    line-height: 1.2;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    box-sizing: border-box;
}

.back-to-top .item + .item {
    border-top: 1px solid #e5e5e5;
}

.back-to-top .item.to-top-btn {
    background-image: url(~@/assets/img/float-toolbar/data_image.png);
    height: 80px;
    opacity: 1;
    border-radius: 4px 4px 0 0;
    transition: all 0.3s;
}

.back-to-top .item.to-top-btn:hover {
    background-image: url(~@/assets/img/float-toolbar/top-blue.png);
}

.back-to-top .item.qrcode {
    position: relative;
    overflow: visible;
    background-image: none;
    padding: 0;
    justify-content: center;
    z-index: 11;
}

.back-to-top .item.qrcode::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 40px;
    background-image: url(~@/assets/img/float-toolbar/qr-code-default.png);
    background-size: cover;
    background-repeat: no-repeat;
    transition: all 0.3s;
}

.back-to-top.blue .item.qrcode:hover::before,
.back-to-top.blue .item.qrcode.active::before {
    background-image: url(~@/assets/img/float-toolbar/qr-code-blue.png);
}

.back-to-top .item.qrcode span {
    font-size: 12px;
    text-align: center;
    display: block;
    margin-top: 35px;
}

.back-to-top .item.qrcode .qr {
    text-align: center;
    position: absolute;
    opacity: 0;
    width: 0;
    overflow: hidden;
    top: -15px;
    right: 70px;
    height: 170px;
    background: #fff;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    padding-top: 15px;
    color: #8893a7;
    z-index: 1000;
    pointer-events: none;
    transition: opacity 0.3s, width 0.3s;
    white-space: nowrap;
    box-sizing: border-box;
}

.back-to-top .item.qrcode .qr img {
    width: 124px;
    height: 124px;
}

.back-to-top .item.qrcode:hover .qr,
.back-to-top .item.qrcode.active .qr {
    opacity: 1 !important;
    width: 150px !important;
    right: 88px !important;
    transition: opacity 0.3s, width 0.3s;
    pointer-events: auto;
    overflow: visible;
    white-space: normal;
}

.back-to-top .item.sszx {
    border-radius: 0 0 4px 4px;
    background-image: url(~@/assets/img/float-toolbar/service-default.png);
}

.back-to-top .item.sszx:hover {
    background-image: url(~@/assets/img/float-toolbar/service-blue.png);
}

.back-to-top.blue .item:hover {
    color: #347fff;
}

@media screen and (max-width: 768px) {
    .back-to-top {
        bottom: 60px;
    }

    .back-to-top .item {
        width: 48px;
        height: 56px;
        font-size: 10px;
        padding-top: 35px;
        padding-bottom: 6px;
        background-size: 24px 24px;
    }

    .back-to-top .item.to-top-btn {
        height: 56px;
    }

    .back-to-top .item.qrcode::before {
        width: 24px;
        height: 24px;
        top: 10px;
    }

    .back-to-top .item.qrcode span {
        margin-top: 37px;
        font-size: 10px;
    }

    .back-to-top .item.qrcode .qr img {
        width: 56px;
        height: 56px;
    }

    .back-to-top .item.qrcode:hover .qr,
    .back-to-top .item.qrcode.active .qr {
        width: 120px !important;
        height: 110px;
    }
}
</style>
